import styled from "styled-components";
export const StyledWrapper = styled.div `
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 30;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  ${({ theme, size, fullscreen, centerMiddle }) => `
  @media (orientation:landscape) {
    padding: ${fullscreen || centerMiddle ? "unset" : "0 1rem 0 1rem"};
  }

  @media (orientation:portrait) {
    padding-top: ${fullscreen || centerMiddle ? "unset" : "7.5rem"};
    padding-bottom: unset;
  }

  @media ${theme.device.medium} {
    padding-top: ${centerMiddle ? "unset" : "7.5rem"};
  }

  @media (orientation: landscape) and ${theme.device.medium} {
    align-items: unset;
  }

  @media only screen and (max-height: 575.98px) and (orientation: landscape) {
    ${size === "l" || (size === "xl" && !centerMiddle)
    ? `
        align-items: unset;`
    : `padding-top: 7.5rem;
        align-items: unset;`} 
      overflow: scroll;
      align-items:center;
      padding-top: unset;
    }
  `}
`;
const sizeMap = {
    s: "26.25rem",
    m: "35rem",
    l: "42.75rem",
    xl: "52.5rem",
    xlMedium: "45rem",
};
export const ModalWrapper = styled.div `
  overflow: ${({ fullscreen }) => (fullscreen ? "hidden" : "auto")};
  margin: ${({ fullscreen }) => (fullscreen ? "0" : "0 1rem 1rem 1rem")};
  height: 100%;
  /* center middle */
  display: flex;
  flex-direction: column;
  justify-content: ${({ centerMiddle }) => centerMiddle ? "center" : "flex-start"};
  align-items: center;

  @media ${({ theme }) => theme.device.medium} {
    overflow: auto;
    margin: 0 1rem 1rem 1rem;
  }
`;
export const ContentBox = styled.div `
  background: white;
  position: relative;
  position: relative;

  ${({ size, theme, fullscreen }) => `
    box-shadow: 0 4px 16px rgba(${theme.colors.transparentBlack}, 0.26);

    max-width: ${sizeMap[size]};

    height: ${fullscreen ? "100vh" : "auto"};
    width: ${fullscreen ? "100vw" : "auto"};

    @media ${theme.device.medium} {
      width: ${sizeMap[size]};
      height: auto;
      ${size === "xl" ? `width: ${sizeMap.xlMedium};` : ""}
      min-height: unset;
    }
    @media ${theme.device.large} {
      width: ${sizeMap[size]};
    }

    @media only screen and (max-height: 575.98px) and (orientation: landscape) and (pointer:coarse) {
      max-width: 100%;
      ${size === "l" || size === "xl"
    ? `width: 100vw; min-height: 100vh;`
    : `width: ${fullscreen ? "100%" : "95vw"}; min-height: 95vh;`}
    }
  `};
`;
export const HeaderBox = styled.div `
  height: 4.75rem;
  width: 100%;
  padding: 0 1rem 0 1rem;
  display: flex;
  align-items: center;

  > span:nth-child(2) {
    flex-grow: 1;
    margin-left: 1rem;
  }

  > button {
    margin-left: 0.5rem;
    width: 2.75rem;
    height: 2.75rem;
    min-width: unset;
  }

  > button > span {
    width: 2.75rem;
    height: 2.75rem;
    min-width: unset;
  }

  > button > span > svg {
    width: 1.125rem;
  }

  @media ${({ theme }) => theme.device.medium} {
    height: 4.5rem;
    padding: 0 1rem 0 1.5rem;

    > button,
    > button > span {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  ${({ type, theme, $color: defaultColor, bgColor: defaultBgColor, iconColor: defaultIconColor, }) => {
    let bgColor = "unset";
    let color = "unset";
    let iconColor = "unset";
    switch (type) {
        case "warning":
            bgColor = `rgba(${theme.colors.transparentWarning}, 0.1)`;
            color = theme.colors.error;
            iconColor = theme.colors.error;
            break;
        case "information":
            bgColor = `rgba(${theme.colors.transparent15}, 0.1)`;
            color = theme.colors.grey15;
            iconColor = theme.colors.grey15;
            break;
        case "error":
            bgColor = `rgba(${theme.colors.transparentError}, 0.1)`;
            color = theme.colors.error;
            iconColor = theme.colors.error;
            break;
        case "success":
            bgColor = `rgba(${theme.colors.transparentSuccess}, 0.1)`;
            color = theme.colors.grey15;
            iconColor = theme.colors.success;
            break;
        case "custom":
            bgColor = defaultBgColor;
            color = defaultColor;
            iconColor = defaultIconColor;
            break;
        default:
            break;
    }
    return `
    background-color: ${bgColor};
    color: ${color};

    > span:nth-child(1) {
      fill: ${iconColor};
    }
  `;
}}

  @media ${({ theme }) => theme.device.medium} {
    padding: 0 1rem 0 2rem;
  }
`;
export const TitleBox = styled.div `
  display: flex;
  padding-top: 1rem;
  padding: ${({ widerPadding, noTitle }) => widerPadding && !noTitle ? `1rem 1.5rem 0` : `1rem 1rem 0`};
  color: ${({ theme }) => theme.colors.black};
  @media ${({ theme }) => theme.device.medium} {
    ${({ noTitle }) => (noTitle ? "" : "padding: 1rem 1rem 0 2rem ;")}
  }

  > span {
    flex-grow: 1;
    margin: 2rem 0.5rem 0 0;
  }

  > span h6 {
    margin: 0;
  }

  > button,
  > button > span {
    width: 2.75rem;
    height: 2.75rem;
    min-width: unset;
  }

  > button > span > svg {
    width: 1.25rem;
  }

  @media ${({ theme }) => theme.device.medium} {
    > button,
    > button > span {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
`;
export const Body = styled.div `
  width: 100%;
  padding: ${({ widerPadding }) => widerPadding ? `1.5rem 1.5rem 2.5rem` : `1rem 1rem 2.5rem`};
  ${({ noHeader }) => (noHeader ? `padding-top: 3rem` : "")}
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  color: ${({ theme }) => theme.colors.black};

  ${({ type }) => type === "error" ||
    type === "success" ||
    type === "warning" ||
    type === "information"
    ? `padding: 1.5rem 1.5rem 2.5rem 1.5rem;`
    : ""}

  > p {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${({ theme }) => `
    @media ${theme.device.small} and (orientation:landscape) and (pointer: coarse) {
      padding-bottom: 1rem;
    }
  `}

  @media ${({ theme }) => theme.device.medium} {
    ${({ type }) => type === "error" ||
    type === "success" ||
    type === "warning" ||
    type === "information"
    ? `padding: 1.5rem 2rem 2rem 2rem;`
    : `padding: 1rem 2rem 2rem;`}
  }

  ${({ hideClose, type, noTitle }) => hideClose && type !== "blocking" && noTitle
    ? `&&& {padding-top: 3rem;}`
    : ""}
`;
export const ButtonFooterContainer = styled.div `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 2rem;
`;
export const ButtonFooterWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  padding-top: 0;
  ${({ reversed }) => (reversed ? "margin-right: auto;" : "width: 100%;")}

  > button {
    width: ${({ hasTwoBtns }) => (hasTwoBtns ? "100%" : "unset")};
  }
  > button:first-child {
    margin: ${({ hasTwoBtns }) => (hasTwoBtns ? "0 0 1.5rem" : "")};
    @media ${({ theme }) => theme.device.medium} {
      margin: 0 0 0 1.5rem;
      ${({ reversed }) => (reversed ? "transform: translate(-1rem);" : "")};
    }
  }

  @media ${({ theme }) => theme.device.small} {
    button {
      ${({ reversed }) => (reversed ? "transform: translate(0);" : "")};
    }
  }

  ${({ theme }) => `
    @media ${theme.device.small} and (orientation:landscape) {
      padding-top: 1rem;
      > button {
        width: 100%;
      }
    }
  `}

  ${({ theme }) => `
    @media ${theme.device.small} and (orientation:portrait) {
      padding-top: 1rem;

      > button {
        width: 100%;
      }

      > button:first-child {
        margin: ${({ hasTwoBtns }) => (hasTwoBtns ? "0 0 1rem 0" : "")};
      }
    }
  `}
  
  @media ${({ theme }) => theme.device.medium} {
    padding-top: 0rem;
    > button {
      @media ${({ theme }) => theme.device.medium} {
        width: unset;
      }
    }
  }

  ${({ reversed }) => reversed ? `flex-grow: 1;` : "flex-direction: row-reverse;"}

  > a {
    margin: 0 -0.5rem 0 0;
    @media ${({ theme }) => theme.device.medium} {
      margin: 0;
    }
  }
`;
export const HeaderWithoutIcon = styled.span `
  width: 1.5rem;
`;
